export const HCP_DATA = [
  {
    heading: "HCPs gaining most patients in Q1 2023",
    table: [
      { text: "HCP 1", value: "+-94.0% ↑" },
      { text: "HCP 2", value: "+2.8% ↑" },
      { text: "HCP 3", value: "+0.2% ↑" },
      { text: "HCP 4", value: "+-65.1% ↑" },
      { text: "HCP 5", value: "+14.4% ↑" },
      { text: "HCP 6", value: "+-54.8% ↑" },
      { text: "HCP 7", value: "+56.7% ↑" },
      { text: "HCP 8", value: "+48.2% ↑" },
      { text: "HCP 9", value: "+53.0% ↑" },
      { text: "HCP 10", value: "+68.4% ↑" },
    ],
  },
  {
    heading: "HCPs improving most in unmet need in Q1 2023",
    table: [
      { text: "HCP 21", value: "+90.2% ↑" },
      { text: "HCP 22", value: "+79.2% ↑" },
      { text: "HCP 23", value: "+22.6% ↑" },
      { text: "HCP 24", value: "+50.2% ↑" },
      { text: "HCP 25", value: "+11.9% ↑" },
      { text: "HCP 26", value: "+16.7% ↑" },
      { text: "HCP 27", value: "+39.4% ↑" },
      { text: "HCP 28", value: "+-18.5% ↑" },
      { text: "HCP 29", value: "+-70.4% ↑" },
      { text: "HCP 30", value: "+93.8% ↑" },
    ],
  },
  {
    heading: "HCPs with most unmet need in Q1 2023",
    table: [
      { text: "HCP 11", value: "-7.9% ↓" },
      { text: "HCP 12", value: "-39.4% ↓" },
      { text: "HCP 13", value: "-55.3% ↓" },
      { text: "HCP 14", value: "-63.7% ↓" },
      { text: "HCP 15", value: "-98.1% ↓" },
      { text: "HCP 16", value: "-76.6% ↓" },
      { text: "HCP 17", value: "-3.1% ↓" },
      { text: "HCP 18", value: "-6.9% ↓" },
      { text: "HCP 19", value: "-83.7% ↓" },
      { text: "HCP 20", value: "-96.3% ↓" },
    ],
  },
  {
    heading: "HCPs gaining most in unmet need in Q1 2023",
    table: [
      { text: "HCP 1", value: "+-94.0% ↑" },
      { text: "HCP 2", value: "+2.8% ↑" },
      { text: "HCP 3", value: "+0.2% ↑" },
      { text: "HCP 4", value: "+-65.1% ↑" },
      { text: "HCP 5", value: "+14.4% ↑" },
      { text: "HCP 6", value: "+-54.8% ↑" },
      { text: "HCP 7", value: "+56.7% ↑" },
      { text: "HCP 8", value: "+48.2% ↑" },
      { text: "HCP 9", value: "+53.0% ↑" },
      { text: "HCP 10", value: "+68.4% ↑" },
    ],
  },
];
